import { render, staticRenderFns } from "./inputbox.vue?vue&type=template&id=773f4cb7&"
import script from "./inputbox.vue?vue&type=script&lang=ts&"
export * from "./inputbox.vue?vue&type=script&lang=ts&"
import style0 from "./inputbox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports